import React, { useState } from 'react';
import { privacyPolicyUrl, termsOfUseUrl } from '../../../../utils';
import { Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import UrlLink from '@material-ui/core/Link';

const useStyles = makeStyles((theme: any) => ({
  terms: {
    maxWidth: 300,
    padding: 0,
    border: ({ error }: any) =>
      `2px solid ${error ? theme.palette.brand.red : 'rgba(0, 0, 0, 0.08)'} `,
    borderRadius: theme.spacing(1.5),
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  textColor: {
    whiteSpace: 'break-spaces',
    textAlign: 'left',
    fontWeight: 500,
  },
  checkbox: {
    color: `${theme.palette.brand.greenLight} !important`,
  },
  error: { textAlign: 'center' },
}));

export default function PrivacyPolicy({ acceptedTerms, inputProps, error }) {
  const classes = useStyles({ error });
  const [checked, setChecked] = useState(false);

  return (
    <Container className={classes.terms}>
      <FormControlLabel
        control={
          <Checkbox
            onClick={() => {
              setChecked(!checked);
            }}
            color={'default'}
            checked={checked}
            inputProps={inputProps}
            name={acceptedTerms}
            className={checked ? classes.checkbox : ' '}
          />
        }
        label={
          <Typography className={classes.textColor} variant="subtitle1">
            I have read and agree to the {'\n'}
            <UrlLink href={termsOfUseUrl} target="_blank">
              Terms of Use
            </UrlLink>
            {' and '}
            <UrlLink href={privacyPolicyUrl} target="_blank">
              Privacy Policy.
            </UrlLink>
          </Typography>
        }
      />
      {error && (
        <FormHelperText className={classes.error} error>
          {error.message}
        </FormHelperText>
      )}
    </Container>
  );
}
